import React from "react";

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

/**
 * Shared `<input type="date">` — clicking anywhere in the field opens the native
 * calendar picker, not just the small calendar icon. Every date-entry field in the
 * app should use this instead of a bare `<input type="date">` so the click-anywhere
 * behavior and cursor affordance are consistent everywhere.
 */
export const DateInput = React.forwardRef<HTMLInputElement, Props>(function DateInput(
  { style, onClick, onFocus, ...rest },
  ref
) {
  const openPicker = (e: React.SyntheticEvent<HTMLInputElement>) => {
    (e.target as HTMLInputElement).showPicker?.();
  };
  return (
    <input
      ref={ref}
      type="date"
      style={{ cursor: "pointer", ...style }}
      onClick={e => { openPicker(e); onClick?.(e); }}
      onFocus={e => { openPicker(e); onFocus?.(e); }}
      {...rest}
    />
  );
});
